import React from 'react'
import moment from 'moment'
import { dropTimeZoneFromDate } from '../../../../shared/libraries/utils/date'
import { DATE_FORMAT } from '../../../../constants'

const PROMO = 'PROMO'
const REFERRAL = 'REFERRAL'

export const CITY_PROGRAMS = { PROMO, REFERRAL }

export const tableColumnsPromo = [
  {
    width: '15%',
    title: 'PROMO BATCH ID',
    dataIndex: 'promoBatchId',
    key: 'promoBatchId',
    render: promoBatchId => {
      return <span>{promoBatchId}</span>
    },
  },
  {
    width: '12%',
    title: 'PROMO CODE',
    dataIndex: 'promoCode',
    key: 'promoCode',
    render: promoCode => {
      return <span>{promoCode}</span>
    },
  },
  {
    width: '10%',
    title: 'START DATE',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: createdAt => {
      const startDate = moment(Number(createdAt)).format('DD/MM/YYYY')

      return <span>{startDate}</span>
    },
  },
  {
    width: '10%',
    title: 'MISSION TRIGGER',
    dataIndex: 'missionsTrigger',
    key: 'missionsTrigger',
    render: missionsTrigger => {
      return <span>{missionsTrigger}</span>
    },
  },
  {
    width: '10%',
    title: 'REWARD',
    dataIndex: 'bonusAmount',
    key: 'bonusAmount',
    render: (bonusAmount, { currencySign }) => {
      return <span>{currencySign + bonusAmount}</span>
    },
  },
  {
    width: '10%',
    title: '# SIGNUPS',
    dataIndex: 'signUpLimit',
    key: 'signUpLimit',
    render: (signUpLimit, { signUps }) => {
      return <span>{`${signUps}/${signUpLimit}`}</span>
    },
  },
  {
    width: '10%',
    title: '# MISSIONS',
    dataIndex: 'missionsCompleted',
    key: 'missionsCompleted',
    render: (missionsCompleted, { missionsTrigger, signUpLimit }) => {
      return (
        <span>{`${missionsCompleted}/${missionsTrigger * signUpLimit}`}</span>
      )
    },
  },
  {
    width: '10%',
    title: 'AMOUNT SPENT',
    dataIndex: 'amountSpent',
    key: 'amountSpent',
    render: (amountSpent, { currencySign }) => {
      return <span>{currencySign + amountSpent}</span>
    },
  },
  {
    width: '10%',
    title: 'STATUS',
    dataIndex: 'isActive',
    key: 'isActive',
    render: isActive => {
      return <span>{isActive ? 'Active' : 'Inactive'}</span>
    },
  },
]

export const tableColumnsReferral = [
  {
    width: '15%',
    title: 'REFERRAL BATCH ID',
    dataIndex: 'userFriendlyBatchId',
    key: 'userFriendlyBatchId',
    render: userFriendlyBatchId => {
      return <span>{userFriendlyBatchId}</span>
    },
  },
  {
    width: '12%',
    title: 'START DATE',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: createdAt => {
      const displayDate = moment(dropTimeZoneFromDate(createdAt)).format(
        DATE_FORMAT,
      )
      return <span>{displayDate}</span>
    },
  },
  {
    width: '10%',
    title: 'MISSION TRIGGER',
    dataIndex: 'requiredMissions',
    key: 'requiredMissions',
    render: requiredMissions => {
      return <span>{requiredMissions}</span>
    },
  },
  {
    width: '10%',
    title: 'REWARD',
    dataIndex: 'bonusAmount',
    key: 'bonusAmount',
    render: (bonusAmount, { currencySign }) => {
      return <span>{currencySign + bonusAmount}</span>
    },
  },
  {
    width: '10%',
    title: '# SIGNUPS',
    dataIndex: 'signUps',
    key: 'signUps',
    render: (signUps, { signUpsLimit }) => {
      return <span>{`${signUps}/${signUpsLimit}`}</span>
    },
  },
  {
    width: '10%',
    title: '# MISSIONS',
    dataIndex: 'completedMissionsAmount',
    key: 'completedMissionsAmount',
    render: (completedMissionsAmount, { requiredMissions, signUps }) => {
      return (
        <span>{`${completedMissionsAmount}/${requiredMissions *
          signUps}`}</span>
      )
    },
  },
  {
    width: '10%',
    title: 'AMOUNT SPENT',
    dataIndex: 'amountSpent',
    key: 'amountSpent',
    render: (amountSpent, { currencySign }) => {
      return <span>{currencySign + amountSpent}</span>
    },
  },
  {
    width: '10%',
    title: 'STATUS',
    dataIndex: 'archivedAt',
    key: 'archivedAt',
    render: archivedAt => {
      return <span>{archivedAt ? 'Inactive' : 'Active'}</span>
    },
  },
]



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityPrograms/options.js